export const PARK_DETAIL = "/interface/park/detail";
// 短信验证码发送接口
export const SEND_CODE = "/interface/park/sendCode";
// 文件上传获取hos
export const UPLOAD_FILE = "/interface/userback/upload-approve-pic";
// 验证短信验证码
export const VALIDATE_CODE = "/interface/park/validateCode";
// 新增园区接口
export const ADD_PARK = "/interface/park/addPark";
// 修改园区
export const UPDATE_PARK = "/interface/park/updatePark";
// 撤销园区
export const UNDO_PARK = "/interface/park/undoPark";
// 查询我的园区列表信息
export const FIND_BY_PHONE = "/interface/park/findByPhone";

// 园区资源列表
export const GET_YQZY_LIST = "/interface/park/rent/list";
// 园区动态列表
export const GET_YQDT_LIST = "/interface/park/dynamic/list";
// 园区政策列表
export const GET_YQZC_LIST = "/interface/park/policy/list";
// 园区活动列表
export const GET_YQHD_LIST = "/interface/park/activity/list";

// 园区列表（可用作筛选）
export const GET_PARK_LIST = "/interface/park/list";

// 获取维度数据
export const GET_DIMENSION_LIST = "/interface/expand/option/find";

// 获取区划列表（异步）
export const GET_DISTRICT_LIST = "/interface/expand/option/find/district/async";
export const GET_CODE_LIST = "/interface/expand/option/find/district/code";
// 根据园区产业类型分组统计
export const GET_INDUSTRY_TYPE = "/interface/park/countIndustryType";

// 租赁列表接口
// 新增
export const ADD_ZLD_YQZY = "/interface/park/rent/add";
// 修改
export const EDIT_ZLD_YQZY = "/interface/park/rent/modify";
// 删除
export const DEL_ZLD_YQZY = "/interface/park/rent/delete";

// 园区动态列表接口
// 新增
export const ADD_ZLD_YQDT = "/interface/park/dynamic/add";
// 修改
export const EDIT_ZLD_YQDT = "/interface/park/dynamic/modify";
// 删除
export const DEL_ZLD_YQDT = "/interface/park/dynamic/delete";

// 园区政策列表接口
// 新增
export const ADD_ZLD_YQZC = "/interface/park/policy/add";
// 修改
export const EDIT_ZLD_YQZC = "/interface/park/policy/modify";
// 删除
export const DEL_ZLD_YQZC = "/interface/park/policy/delete";

// 园区活动列表接口
// 新增
export const ADD_ZLD_YQHD = "/interface/park/activity/add";
// 修改
export const EDIT_ZLD_YQHD = "/interface/park/activity/modify";
// 删除
export const DEL_ZLD_YQHD = "/interface/park/activity/delete";

// 园区企业所属行业分布
export const GET_PARK_INDUSTRY_LIST =
  "/interface/park/corporation/distribute/industry";

// 园区企业注册资本分布
export const GET_PARK_CAPITAL_LIST =
  "/interface/park/corporation/distribute/capital";

// 园区企业
export const GET_PARK_COM_LIST = "/interface/park/corporation/part";

// 园区动态详情
export const GET_YQDT_DETAIL = "/interface/park/dynamic/detail";
// 园区政策详情
export const GET_YQZC_DETAIL = "/interface/park/policy/detail";
// 园区活动详情
export const GET_YQHD_DETAIL = "/interface/park/activity/detail";
// 园区反馈建议提交
export const GET_USER_BACK = "/interface/userback/add";
// 根据名称查询区划code
export const GET_CODE_ID = "/interface/expand/option/find/district/name";
// 获取登录后企业信息（第三方接口）
export const GET_ENTERPRISE = "/qfpt/openApi/getEnterpriseInfo";

// 楼宇
export const PARK_BUILDING_LIST = "/interface/park/building/list"; // 楼宇列表
export const ADD_PARK_BUILDING = "/interface/park/building/add"; // 新增楼宇
export const MODIFY_PARK_BUILDING = "/interface/park/building/modify"; // 修改楼宇
export const DELETE_PARK_BUILDING = "/interface/park/building/delete"; // 删除楼宇
export const SORT_PARK_BUILDING = "/interface/park/building/sort"; // 楼宇排序

// 楼层
export const BUILDING_FLOOR_LIST = "/interface/building/floor/list"; // 园区楼层信息表
export const ADD_BUILDING_FLOOR = "/interface/building/floor/add"; // 新增楼层
export const MODIFY_BUILDING_FLOOR = "/interface/building/floor/modify"; // 修改楼层
export const DELETE_BUILDING_FLOOR = "/interface/building/floor/delete"; // 删除楼层
export const SORT_BUILDING_FLOOR = "/interface/building/floor/sort"; // 楼层排序

// 园区详情
export const PARK_CORPORATION_LIST = "/interface/park/corporation/list"; // 企业列表接口
export const ADD_PARK_CORPORATION = "/interface/park/corporation/add"; // 企业新增接口
export const MODIFY_PARK_CORPORATION = "/interface/park/corporation/modify"; // 企业修改接口
export const DELETE_PARK_CORPORATION = "/interface/park/corporation/delete"; // 企业删除接口
export const SORT_PARK_CORPORATION = "/interface/park/corporation/sort"; // 企业排序接口

export const GET_MAPKEY = "/interface/expand/option/get-mapkey";

export const CHECK_IS_MANAGER = "/interface/park/checkIsManager";

export default {
  PARK_DETAIL,
  SEND_CODE,
  UPLOAD_FILE,
  VALIDATE_CODE,
  ADD_PARK,
  UPDATE_PARK,
  UNDO_PARK,
  FIND_BY_PHONE,
  GET_YQZY_LIST,
  GET_YQDT_LIST,
  GET_YQZC_LIST,
  GET_YQHD_LIST,
  GET_PARK_LIST,
  GET_DIMENSION_LIST,
  GET_DISTRICT_LIST,
  GET_CODE_LIST,
  GET_USER_BACK,
  GET_ENTERPRISE,
  GET_CODE_ID,

  // ---------治理端给到服务端接口---------
  ADD_ZLD_YQZY,
  EDIT_ZLD_YQZY,
  DEL_ZLD_YQZY,

  ADD_ZLD_YQDT,
  EDIT_ZLD_YQDT,
  DEL_ZLD_YQDT,

  ADD_ZLD_YQZC,
  EDIT_ZLD_YQZC,
  DEL_ZLD_YQZC,

  ADD_ZLD_YQHD,
  EDIT_ZLD_YQHD,
  DEL_ZLD_YQHD,

  GET_PARK_INDUSTRY_LIST,
  GET_PARK_CAPITAL_LIST,
  GET_PARK_COM_LIST,
  GET_YQDT_DETAIL,
  GET_YQZC_DETAIL,
  GET_YQHD_DETAIL,

  PARK_BUILDING_LIST,
  ADD_PARK_BUILDING,
  MODIFY_PARK_BUILDING,
  DELETE_PARK_BUILDING,
  SORT_PARK_BUILDING,

  BUILDING_FLOOR_LIST,
  ADD_BUILDING_FLOOR,
  MODIFY_BUILDING_FLOOR,
  DELETE_BUILDING_FLOOR,
  SORT_BUILDING_FLOOR,

  PARK_CORPORATION_LIST,
  ADD_PARK_CORPORATION,
  MODIFY_PARK_CORPORATION,
  DELETE_PARK_CORPORATION,
  SORT_PARK_CORPORATION,

  GET_MAPKEY,
  CHECK_IS_MANAGER,
};
